import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { Accordion, Grid, Header, Icon, Image, Label, Message, Segment } from "semantic-ui-react";
import styles  from "../../../../Assessment/AssessmentInfoSlideControls/LearnMoreTemplate.module.css"

const cdnRoute = process.env.REACT_APP_CDN_ROUTE + "/family/";
const iconRoute = process.env.REACT_APP_CDN_ROUTE + "/icons/";

const FamilyMeetingLearnMore: React.FC = ( ) => {
  const [activeAccordionIndexes] = useState([0]);

  const renderAccordionTips = () => {
    return (
      <>       
        <Grid stackable className={styles.learnMoreFullDiv} >
          <Grid.Row columns='equal' stretched className={styles.highlightsItemRow} >
            <Grid.Column stretched className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`} >
              <Segment raised className={styles.highlightsItemWhiteBG} >  
                <Header as='h2' icon className={styles.highlightsItemHeader} >
                  <Image src={`${iconRoute}PrimaryCaregiverIcon.png`} className={styles.highlightsItemHeaderImgIcon} />
                  <p className={styles.highlightsItemHeaderTitle} >PRIMARY CAREGIVER </p>
                  <Header.Subheader>
                    <p className={styles.learnMoreAccordionTextEmphasis} >
                      Decide who will be responsible for specific tasks.</p>
                    <p className={styles.learnMoreAccordionText} >You can name a primary caregiver who will be responsible for orchestrating things in the event of an emergency.</p> 
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
            <Grid.Column stretched container className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`} >
              <Segment raised className={styles.highlightsItemWhiteBG} >  
                <Header as='h2' icon className={styles.highlightsItemHeader} >
                  <Image src={`${iconRoute}BoundariesIcon.png`} className={styles.highlightsItemHeaderImgIcon} />
                  <p className={styles.highlightsItemHeaderTitle} >CONSIDER BOUNDARIES</p>
                  <Header.Subheader> 
                    <p className={styles.learnMoreAccordionText} ><span className={styles.learnMoreAccordionTextEmphasis} >
                      Consider everyone's limits and boundaries</span> and be realistic about how much you 
                      can and are willing to do.</p> 
                    <p className={styles.learnMoreAccordionText} >It is important to understand the responsibility of taking on caregiving duties.</p>
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
          </Grid.Row>
          <Grid.Row stretched columns='equal' className={styles.highlightsItemRow} >
            <Grid.Column stretched className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`} >
              <Segment raised className={styles.highlightsItemWhiteBG} >  
                <Header as='h2' icon className={styles.highlightsItemHeader} >
                  <Image src={`${iconRoute}GroupDiscussIcon.png`} className={styles.highlightsItemHeaderImgIcon} />
                  <p className={styles.highlightsItemHeaderTitle} > DISCUSS STRENGTHS </p>
                  <Header.Subheader>  
                    <p className={styles.learnMoreAccordionTextEmphasis} >
                      Discuss strengths and weaknesses when delegating caregiving responsibilities and tasks. </p>
                    <p className={styles.learnMoreAccordionText} >Finding out what each person is good at can be very helpful in planning for the future. 
                      Some people are good at managing finances while others would be better suited to dealing 
                      with medical tasks.</p> 
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
            <Grid.Column stretched className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle} `}>
              <Segment raised className={styles.highlightsItemWhiteBG} >  
                <Header as='h2' icon className={styles.highlightsItemHeader} >
                  <Image src={`${iconRoute}TogetherIcon.png`} className={styles.highlightsItemHeaderImgIcon} />
                  <p className={styles.highlightsItemHeaderTitle} >HELP & SUPPORT </p>
                  <Header.Subheader> 
                    <p className={styles.learnMoreAccordionTextEmphasis} >If you or other family members live in a different area than
                      the older adult, you'll want to discuss the ways you can help support them. </p>
                    <p className={styles.learnMoreAccordionText} >There are things that you don't need to be present for like giving emotional support, arranging for professional
                      caregivers, researching options for care, or providing financial support or managing finances.</p>
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </>
    );
  };

  const accordions = [
    { key: 'tips',
      index: 0,
      title: { 
        icon: <Icon name='dropdown' className={styles.learnMoreAccordionLabelTitleIcon} />, 
        content: <Label className={styles.learnMoreAccordionLabelTitle} > Tips On Holding A Successful And Productive Family Meeting </Label> },
      content: { 
        content: (<Message className={styles.learnMoreAccordionMessageBox} content={renderAccordionTips()}/>)
      }
    }
  ];

  return (
    <>
      <Segment className={styles.learnMoreBackgroundImg} style = {{ backgroundImage: `url(${cdnRoute}FamilyMeetingInfoOne.jpg)`, }}>
        <div className={styles.learnMoreModalContent}>

          <div className={styles.learnMoreAccordionFullDivGrid} >
            <div className={styles.learnMoreAccordionFullDiv} >
              <Accordion panels={accordions} className={styles.learnMoreModalAccordionGroup} defaultActiveIndex={activeAccordionIndexes} exclusive={false} />
            </div> 
          </div>  

        </div>
      </Segment>      
        <p className={styles.learnMoreAccordionText} style={{float: 'right', fontStyle: 'italic', display: 'flex'}}>Image from The National Institute On Aging</p>
    </>
  );  
};

export default observer(FamilyMeetingLearnMore);
